<template>
  <div class="editor-js__wrapper">
    <EditorJS
      :value="value"
      @input="onInput"
      class="editor-js"
      :class="{ error: observableError }"
      :imgUploadURL="imgUploadURL"
      :customComponents="customComponents"
    />
    <bimErrorField :error="observableError" />
  </div>
</template>

<script>
import ValidationFormMixin from '@/utils/validate2/validation-form-mixin'
import bimErrorField from '@/components/form/bimErrorField/bimErrorField'
import EditorJS from '@/components/core/EditorJS/index.vue'

export default {
  name: 'bimEditorJS',
  mixins: [ValidationFormMixin],
  components: {
    bimErrorField,
    EditorJS,
  },
  props: {
    /**
     * Значение текстового поля
     */
    value: {
      type: [Object, String],
      default: () => ({}),
    },
    imgUploadURL: String,
    /**
     * Кастомные блоки для редактора<br/>
     * передавать объектом { Custom, Custom2, Custom3 }
     */
    customComponents: Object
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
      this.$emit('blur')
    },
  },
}
</script>

<style lang="scss" scoped>
.editor-js__wrapper {
  .editor-js.error {
    border-color: $red-color-400;
  }
}
</style>
